export type AuthMode = 'sign-up' | 'sign-in';

// Which form the combined sign-up/sign-in screen opens in. The landing
// screen links returning users straight to sign-in with ?mode=sign-in
// (issue #41); anything else, including a repeated or unknown value, opens
// sign-up.
export function initialAuthMode(param: string | string[] | undefined): AuthMode {
  return (Array.isArray(param) ? param[0] : param) === 'sign-in' ? 'sign-in' : 'sign-up';
}
